<template>
	<div id="background" class="newsletter-form-container" v-if="showModal" @click="closeNewsletterModal($event)">
		<div class="newsletter-modifier-container">
			<div class="newsletter-form-content">
				<div class="input-container input-select">
					<label for="platform">{{ `${$t('controlPanel.landingPage.selectPlatformForm')}` }}</label>
					<div>
						<select id="platform" v-model="newsletter.platform">
							<option value="DRC">DRC</option>
							<option value="GOP">GOP</option>
						</select>
						<Hint
							:label="''"
							:hint="`${$t('controlPanel.landingPage.selectHintForm')}`"
						/>
					</div>
				</div>
				<NewsletterInputText
					:newsletter="newsletter"
					:field="`topic`"
					:placeholder="`${$t('controlPanel.landingPage.exampleTopic')}`"
					:hint="`${$t('controlPanel.landingPage.commonHintForm', NewsletterFormService.validations.topic)}`"
					:label="`${$t('controlPanel.landingPage.topicForm')}`"
					:validations="NewsletterFormService.validations.topic"
				/>
				<NewsletterInputText
					:newsletter="newsletter"
					:field="`title`"
					:placeholder="`${$t('controlPanel.landingPage.exampleTitle')}`"
					:hint="`${$t('controlPanel.landingPage.commonHintForm', NewsletterFormService.validations.title)}`"
					:label="`${$t('controlPanel.landingPage.titleForm')}`"
					:validations="NewsletterFormService.validations.title"
				/>
				<NewsletterInputText
					:newsletter="newsletter"
					:field="`message`"
					:placeholder="`${$t('controlPanel.landingPage.exampleMessage')}`"
					:hint="`${$t('controlPanel.landingPage.commonHintForm', NewsletterFormService.validations.message)}`"
					:label="`${$t('controlPanel.landingPage.messageForm')}`"
					:validations="NewsletterFormService.validations.message"
				/>
				<NewsletterInputText
					:newsletter="newsletter"
					:field="`redirectionButtonText`"
					:placeholder="`${$t('controlPanel.landingPage.exampleButtonRedirect')}`"
					:hint="`${$t('controlPanel.landingPage.commonHintForm', NewsletterFormService.validations.redirectionButtonText)}`"
					:label="`${$t('controlPanel.landingPage.redirectButtonForm')}`"
					:validations="NewsletterFormService.validations.redirectionButtonText"
				/>
				<NewsletterInputText
					:newsletter="newsletter"
					:field="`redirectUrl`"
					:placeholder="`https://www.example.com`"
					:hint="`${$t('controlPanel.landingPage.redirectButtonHintForm', NewsletterFormService.validations.redirectUrl)}`"
					:label="`${$t('controlPanel.landingPage.redirectButtonUrlForm')}`"
					:validations="NewsletterFormService.validations.redirectUrl"
				/>

				<NewsletterTemplate :newsletter="newsletter"/>
			</div>
			<div class="newsletter-form-buttons">
				<button :class="['save', {'disabled' : !noErrors()}]" @click="saveNewsletter($event)">
					{{ `${$t('controlPanel.landingPage.buttons.save')}` }}
				</button>
				<button id="button-close" class="close" @click="closeNewsletterModal($event)">
					{{ `${$t('controlPanel.landingPage.buttons.close')}` }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import NewsletterTemplate from "@/drc/pages/controlPanel/landingPage/NewsletterTemplate";
import Hint from "@/common/components/Hint";
import NewsletterInputText from "@/drc/pages/controlPanel/landingPage/NewsletterInputText";
import * as NewsletterFormService from "@/drc/services/newsletter.form.service";
import * as GRAPHQL_SERVICE from "@/drc/services/drc-graphql-service";

export default {
	name: "NewsletterForm",
	components: {
		NewsletterTemplate,
		NewsletterInputText,
		Hint
	},
	props: {
		newsletterChange: {
			type: Function,
			required: true
		}
	},
	data() {
		return {
			showModal: false,
			newsletter: {},
			NewsletterFormService: NewsletterFormService
		}
	},
	methods: {
		closeNewsletterModal(event, forceClose) {
			if (event.target.id === 'button-close' || event.target.id === 'background' || forceClose) {
				this.showModal = false;
			}
		},
		openNewsletterModal(newsletter) {
			this.newsletter = newsletter
			this.showModal = true;
		},
		saveNewsletter(event) {
			if (this.noErrors()) {
				let forceClose = true;

				GRAPHQL_SERVICE.createNewsLetter(this.newsletter)
					.then((response) => {
						this.newsletterChange(this.newsletter);
						forceClose = true;
						this.newsletter.id = Number(response.data.createNewsletter)
					})
					.catch((error) => {
						console.error(error)
						forceClose = false;
					})
					.finally(() => this.closeNewsletterModal(event, forceClose))
			}
		},
		noErrors() {
			return NewsletterFormService.validateForm(this.newsletter).length === 0;
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.newsletter-form-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	overflow-y: auto;

	.newsletter-modifier-container {
		background: #001f33;
		padding: 20px;
		border-radius: 8px;
		width: 85%;
		max-width: 1300px;
		height: fit-content;
		overflow: auto;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 25px;

		.newsletter-form-content {
			display: flex;
			flex-direction: column;
			gap: 15px;

			.input-select {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				gap: 25px;
				row-gap: 5px;

				label {
					flex-basis: 20%;
				}

				div {
					select {
						padding: 2px 5px;
						border-radius: 4px;
					}
				}
			}
		}

		.newsletter-form-buttons {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			flex-wrap: wrap;
			gap: 25px;

			button {
				cursor: pointer;
				border-radius: 4px;
				padding: 5px 10px;
				border: none;
				text-transform: uppercase;
				color: $color-primary-dark;
				font-size: 14px;
				font-weight: 400;
			}

			.close {
				background: $color-disabled-button-backgroud;
			}

			.save {
				background: $success;
			}

			.disabled {
				background: $color-disabled-button-backgroud;
				cursor: not-allowed;
			}
		}
	}

}
</style>
